import React from 'react';

export default function AdvisorCard({ advisor }) {
  return (
    <div
      className=""
      style={{ borderColor: 'var(--color-border)' }}
    >
      <div className="flex items-start gap-4">
        <div
          className="w-12 h-12 rounded-full flex items-center justify-center text-sm font-heading font-semibold text-white flex-shrink-0"
          style={{ background: 'var(--color-secondary)' }}
        >
          {advisor?.initials}
        </div>
        <div>
          <h3 className="font-heading text-base font-semibold mb-0.5" style={{ color: 'var(--color-primary)' }}>{advisor?.name}</h3>
          <p className="text-xs font-caption text-gray-500 mb-3">{advisor?.title}</p>
          <p className="text-sm font-body text-gray-600 leading-relaxed">{advisor?.bio}</p>
        </div>
      </div>
    </div>
  );
}
